import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import backgroud from "../assets/img/DSC07851-2 copy tamga.jpg";
import scroll from "../assets/img/Scroll.png";
import "../styles/pages.scss";
import h1Img from "../assets/img/tour-guide 1.png";
import h2Img from "../assets/img/travelling 1.png";
import h3Img from "../assets/img/hands 1.png";
import h4Img from "../assets/img/medical-team 1.png";
import { HomeCard1 } from "../components/HomeCard1";
import homePic1 from "../assets/img/Group 1000003580.png";
import homePic2 from "../assets/img/homePic2.png";
import homePic3 from "../assets/img/homePic3.png";
import homePic5 from "../assets/img/s2.png";
import homePic6 from "../assets/img/s3.png";
import homePic7 from "../assets/img/s1.png";
import homePic12 from "../assets/img/e1.png";
import homePic13 from "../assets/img/e2.png";
import homePic14 from "../assets/img/e3.png";
import calendar from "../assets/img/calendar.png";
import { HomeCard2 } from "../components/HomeCard2";
import { HomeCard4 } from "../components/HomeCard4";
import { HomeCard5 } from "../components/HomeCard5";
import { Data, GetTravelData } from "../Location";
import emailjs from "emailjs-com";
import { SERVICE_ID, TEMPLATE_ID, USER_ID } from "../KEYS.js";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { GetAll } from "../server.js";
import { useNavigate } from "react-router-dom";

function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, USER_ID).then(
        (result) => {
            window.location.reload();
        },
        (error) => {}
    );
}

function IsSameDay(a, b) {
    return (
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
    );
}

export function Home() {
    const [data, setData] = useState(false);
    const [travelData, setTravelData] = useState(false);
    const [reviewAvtive, setReviewAvtive] = useState([true, false, false]);
    const [sendActive, setSendACtive] = useState("none");
    const [cal, setCalendar] = useState(false);
    const buttonRef = useRef(null);
    const calendarRef = useRef(null);
    const [dates, setDate] = useState([]);

    useEffect(() => {
        GetTravelData().then((r) => {
            setTravelData(r);
        });
        GetAll().then((r) => {
            const d = r.map((i) => {
                return {
                    startDate: new Date(i.data.startDate + "T00:00:00"),
                    endDate: new Date(i.data.endDate + "T00:00:00"),
                };
            });
            setDate(d);
        });
        Data().then((r) => {
            setData(r);
        });
        const handleClickOutside = (e) => {
            if (
                calendarRef.current &&
                !calendarRef.current.contains(e.target) &&
                !buttonRef.current.contains(e.target)
            ) {
                setCalendar(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () =>
            document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const navigate = useNavigate();
    return (
        <div className="page">
            <img className="pageBackground" src={backgroud} />
            <img className="pageBackgroundScroll" src={scroll} />
            <div className="pageTop centerFlexCol">
                <div className="homeTitle">
                    {data ? data.home.MainTitle : ""}
                </div>
                <div
                    className="homeBtn"
                    onClick={() => {
                        setSendACtive("inherit");
                    }}
                >
                    {data ? data.home.MainBtn : ""}
                </div>
                <form
                    className="request"
                    style={{ display: sendActive }}
                    onSubmit={sendEmail}
                >
                    <div className="mainText">{data && data.request.title}</div>
                    <div className="subText">
                        {data && data.request.subTitle}
                    </div>
                    <div className="input1">
                        <input
                            className="input"
                            name="name"
                            placeholder={data && data.request.name}
                        />
                        <input
                            className="input"
                            name="phone"
                            type="tel"
                            placeholder={data && data.request.phone}
                        />
                    </div>
                    <input
                        className="input"
                        name="email"
                        type="email"
                        placeholder={data && data.request.mail}
                    />
                    <textarea
                        className="inputt"
                        name="value"
                        placeholder={data && data.request.value}
                    />
                    <input type="submit" className="btn"></input>
                    <div
                        className="off"
                        onClick={() => {
                            setSendACtive("none");
                        }}
                    >
                        X
                    </div>
                </form>
            </div>
            <div className="pageContent">
                <div className="homeContent1" id="1">
                    <div className="title">
                        {data ? data.home.ServiceText : ""}
                    </div>
                    <div className="cards">
                        <HomeCard1
                            img={h1Img}
                            title={data ? data.home.Services[0].Title : ""}
                            text={data ? data.home.Services[0].Text : ""}
                            onClick={() => {
                                navigate("/data1");
                            }}
                        />
                        <HomeCard1
                            img={h2Img}
                            title={data ? data.home.Services[1].Title : ""}
                            text={data ? data.home.Services[1].Text : ""}
                        />
                        <HomeCard1
                            img={h3Img}
                            title={data ? data.home.Services[2].Title : ""}
                            text={data ? data.home.Services[2].Text : ""}
                        />
                        <HomeCard1
                            img={h4Img}
                            title={data ? data.home.Services[3].Title : ""}
                            text={data ? data.home.Services[3].Text : ""}
                        />
                    </div>
                </div>
                <div className="homeContent2">
                    <div className="text">
                        <div className="title">
                            {data ? data.home.AboutTitle : ""}
                        </div>
                        <div className="inner">
                            {data ? data.home.AboutText : ""}
                        </div>
                        <div
                            className="btn"
                            onClick={() => {
                                window.location.href = "/about";
                            }}
                        >
                            {data ? data.home.AboutBtn : ""}
                        </div>
                    </div>
                    <div className="img">
                        <img className="house" src={homePic1}></img>
                        <img className="plane" src={homePic2}></img>
                    </div>
                </div>
                <div className="homeContent3">
                    <div className="card">
                        <img className="img3" src={homePic3}></img>
                        <div className="cardData">
                            <div className="title bold">
                                {data && data.home.timetable}
                            </div>
                            <div className="cardBtn">
                                <img className="icon" src={calendar}></img>
                                <div
                                    ref={buttonRef}
                                    className="btn"
                                    onClick={() => {
                                        setCalendar(!cal);
                                    }}
                                >
                                    {data && data.home.view}
                                </div>
                                {cal && (
                                    <div ref={calendarRef} className="calendar">
                                        <Calendar
                                            tileClassName={({ date }) => {
                                                for (const range of dates) {
                                                    const start = new Date(
                                                        range.startDate
                                                    );
                                                    const end = new Date(
                                                        range.endDate
                                                    );
                                                    if (IsSameDay(date, start))
                                                        return "range-start";
                                                    if (IsSameDay(date, end))
                                                        return "range-end";
                                                    if (
                                                        date > start &&
                                                        date < end
                                                    )
                                                        return "range-middle";
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="homeContent4" id="2">
                    <div className="title">{data ? data.home.Tops : ""}</div>
                    <div className="line hi"></div>
                    <div className="datas">
                        <div className="cards">
                            <HomeCard2
                                num={1}
                                img={homePic5}
                                text={travelData ? travelData[1].name : ""}
                            />
                            <HomeCard2
                                num={0}
                                img={homePic6}
                                text={travelData ? travelData[0].name : ""}
                            />
                            <HomeCard2
                                num={0}
                                img={homePic7}
                                text={travelData ? travelData[0].name : ""}
                            />
                        </div>
                    </div>
                </div>

                <div className="homeContent6" id="4">
                    <div className="title">
                        {data ? data.home.EmotionTitle : ""}
                    </div>
                    <div className="cards">
                        <HomeCard4
                            img={homePic12}
                            text={data ? data.home.Emotions[0].Text : ""}
                            name={data ? data.home.Emotions[0].From : ""}
                            active={reviewAvtive}
                            num={0}
                            right={() => {
                                setReviewAvtive([false, true, false]);
                            }}
                            left={() => {
                                setReviewAvtive([false, false, true]);
                            }}
                        />
                        <HomeCard4
                            img={homePic13}
                            text={data ? data.home.Emotions[1].Text : ""}
                            name={data ? data.home.Emotions[1].From : ""}
                            active={reviewAvtive}
                            num={1}
                            right={() => {
                                setReviewAvtive([false, false, true]);
                            }}
                            left={() => {
                                setReviewAvtive([true, false, false]);
                            }}
                        />
                        <HomeCard4
                            img={homePic14}
                            text={data ? data.home.Emotions[2].Text : ""}
                            name={data ? data.home.Emotions[2].From : ""}
                            active={reviewAvtive}
                            num={2}
                            right={() => {
                                setReviewAvtive([true, false, false]);
                            }}
                            left={() => {
                                setReviewAvtive([false, true, false]);
                            }}
                        />
                    </div>
                </div>
                <div className="homeContent7" id="QA">
                    <div className="title">
                        {data ? data.home.FAQTitle : ""}
                    </div>
                    <div className="title2">
                        {data ? data.home.FAQText : ""}
                    </div>
                    <div className="cards">
                        {data
                            ? data.home.FAQ.map((item, index) => {
                                  return (
                                      <HomeCard5
                                          key={index}
                                          quest={item.Quest}
                                          answer={item.Ans}
                                      />
                                  );
                              })
                            : ""}
                    </div>
                </div>
            </div>
        </div>
    );
}
